import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row } from 'antd';
import FeedbackAdd from './FeedbackAdd';
import moment from 'moment';
import TableWithSorter from '../Common/TableWithSorter';
import FeedbackDetails from './FeedbackDetails';
import FeedbackEdit from './FeedbackEdit';

const FeedbackFormSection = ({
  title,
  toggleFormAdd,
  isAddFormModalOpen,
  unitOfferStartDate,
  dateFormat,
  feedbackTemplates,
  onSubmitAdd,
  editStatus,
  toggleFormEdit,
  isEditFormModalOpen,
  onSubmitEdit,
  feedbackForms,
  columns,
  forTrainer,
}) => {
  return (
    <section>
      <Row justify="space-between">
        <h1>{title}</h1>
        <div>
          {feedbackForms.length < 1 && (
            <Button onClick={toggleFormAdd}>Add Feedback</Button>
          )}
          <FeedbackAdd
            isOpen={isAddFormModalOpen}
            toggle={toggleFormAdd}
            initialValues={{
              isOpen: null,
              startDate: moment(unitOfferStartDate, dateFormat),
              endDate: moment(
                moment(unitOfferStartDate, dateFormat).add(1, 'days')
              ),
              forTrainer: forTrainer,
            }}
            feedbackTemplates={feedbackTemplates}
            onSubmit={onSubmitAdd}
            status={editStatus}
          />
        </div>
      </Row>
      <div>
        <TableWithSorter
          tableLayout="auto"
          scroll={{ x: 1000 }}
          expandable={{
            expandedRowRender: (feedback) => (
              <section>
                <FeedbackDetails feedback={feedback} />
                <br />
                <Button onClick={toggleFormEdit} type="primary">
                  Edit
                </Button>
                <FeedbackEdit
                  isOpen={isEditFormModalOpen}
                  toggle={toggleFormEdit}
                  initialValues={{
                    ...feedback,
                    startDate: moment(feedback.startDate, dateFormat),
                    endDate: moment(feedback.endDate, dateFormat),
                  }}
                  onSubmit={(values) => onSubmitEdit(values, feedback._id)}
                  status={editStatus}
                />
              </section>
            ),
          }}
          dataSource={feedbackForms}
          columns={columns}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30'],
          }}
        />
      </div>
    </section>
  );
};

FeedbackFormSection.propTypes = {
  title: PropTypes.string,
  toggleFormAdd: PropTypes.func,
  isAddFormModalOpen: PropTypes.bool,
  unitOfferStartDate: PropTypes.string,
  dateFormat: PropTypes.string,
  feedbackTemplates: PropTypes.array,
  onSubmitAdd: PropTypes.func,
  editStatus: PropTypes.object,
  toggleFormEdit: PropTypes.func,
  isEditFormModalOpen: PropTypes.bool,
  onSubmitEdit: PropTypes.func,
  feedbackForms: PropTypes.array,
  columns: PropTypes.array,
  forTrainer: PropTypes.bool,
};

export default FeedbackFormSection;
